module.exports = __webpack_public_path__ + "static/img/btnBg.ac97f73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cashWheel/btnBg.png
// module id = qB9W
// module chunks = 0